/**
 * @author [zhaowenjie08]
 * @email [zhaowenjie08@58.com]
 * @create date 2021-04-15 15:23:27
 * @modify date 2021-04-15 15:23:27
 * @desc [主应用默认容器]
 */
import React from 'react'
import ProLayout from '@ant-design/pro-layout'
// 不能放在src外面，暂时先放这里
import { withRouter, RouteComponentProps } from 'react-router'
import PropTypes from 'prop-types'
import defaultSettings from '../../defaultSettings'
import { Footer } from 'antd/lib/layout/layout'
import { Breadcrumb } from 'antd'
import RightContent from '@/components/layout/RightContent'
import { getMenuList, getUserInfo } from '@/service'
import styles from './default.module.less'
import { IUseInfoData } from './index.d'

interface Props extends RouteComponentProps {
  children: any;
  showBreadcrumb: boolean;
  footerRender: boolean;
  menuRender: boolean;
  headerRender: boolean;
}

interface States {
  leftMenu: Array<any>;
  breadcrumb: Array<any>;
  menu: Array<any>;
  currentPathName: string;
  collapsed: boolean;
  useInfo: IUseInfoData;
}

class DefaultLayout extends React.Component<Props, States> {
  static propTypes = {
    match: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired
  }

  state: States = {
    leftMenu: [],
    breadcrumb: [],
    menu: [],
    currentPathName: '',
    collapsed: false,
    useInfo: {}
  };

  componentDidMount () {
    this.getMenuQuery()
    this.getUserInfoData()
    this.setState({
      currentPathName: location.pathname
    })
  }

  getUserInfoData = () => {
    getUserInfo().then((res: { data: IUseInfoData }) => {
      const data = res.data || {}
      localStorage.setItem('opencms_iphone', `${data.userRealName}_${data.userId}_${data.companyName}`)
      localStorage.setItem('userName', data.userRealName || '')
      localStorage.setItem('userId', `${data.userId}` || '')
      this.setState({
        useInfo: data
      })
    })
  }

  getMenuQuery = () => {
    getMenuList({}).then((res: any) => {
      this.setState({
        menu: this.filterVisibleMenu(res.data)
      })
      localStorage.setItem('menu', JSON.stringify(res.data))
      const allPageMenu = this.filterPages(res.data)
      // 设置当前激活的菜单和面包屑
      const menuPaths = this.findMenuPath(allPageMenu, location.pathname)
      this.setState({
        breadcrumb: menuPaths,
        currentPathName: location.pathname
      })
    })
  };

  filterPages = (menus: any[]):any => {
    const ret = []
    if (menus) {
      for (const item of menus) {
        if ([2, 3, 5].includes(item.authority_type)) {
          continue
        }
        ret.push({
          pathKey: item.key,
          path: item.url || '/',
          name: item.title,
          children: this.filterPages(item.children)
        })
      }
      return ret
    }
  };

  filterVisibleMenu = (menus: any[]):any => {
    const ret: any[] = [];

    (menus || []).map((item:any) => {
      if (![2, 3, 5, 6].includes(item.authority_type)) {
        ret.push({
          pathKey: item.key,
          path: item.url || '/',
          name: item.title,
          children: this.filterVisibleMenu(item.children)
        })
      }
      return item
    })
    return ret
  };

  // 寻找current路径
  findMenuPath = (menus: Array<any> = [], currentPath = '', parentPath: Array<any> = []):any => {
    for (const item of menus) {
      let result = []
      // 命中，而且命中的是叶子节点
      if (item.path === currentPath && !(item.children && item.children.length)) {
        result = [...parentPath, item]
      } else if (item.children && item.children.length) {
        result = this.findMenuPath(item.children, currentPath, [...parentPath, item])
      } else {
        result = []
      }
      if (result.length) {
        // 寻址结束，跳出循环
        return result
      }
    }
    return []
  };

  // 设置激活的tab和页面跳转
  clickMenuItem = (item: any) => {
    if (item.path === '/') {
      item.path = '/webapp/main/404'
    }
    const menuPaths = this.findMenuPath(this.state.menu, item.path)
    this.setState({
      breadcrumb: menuPaths,
      currentPathName: item.path.includes('?') ? item.path.split('?')[0] : item.path
    })
    item.path && window.history.pushState('', '', item.path)
  }

  onCollapse = (collapsed: boolean) => {
    this.setState({ collapsed })
  };

  render () {
    const { showBreadcrumb, footerRender, menuRender, headerRender } = this.props
    if (!menuRender) {
      defaultSettings.menuRender = false
    }
    if (!headerRender) {
      defaultSettings.headerRender = false
    }
    const { menu, currentPathName, breadcrumb } = this.state
    const route = {
      path: '/',
      routes: menu
    }
    const companyName = this.state.useInfo?.companyName || ''
    return (
      <>
        <ProLayout
          className={styles.cmsDefaultLayout}
          { ...defaultSettings}
          title={`${defaultSettings.title}${companyName ? ' - ' + companyName : ''}`}
          route={route}
          location={{ pathname: currentPathName }}
          menuItemRender={(item, dom) => (
              <a onClick={() => this.clickMenuItem(item)}>{ dom }</a>
          )}
          rightContentRender={() => <RightContent useInfo={this.state.useInfo} />}
          footerRender={() => {
            return footerRender
              ? (<Footer style={{ textAlign: 'center', padding: '0 0 12px' }}>
                    OpenCMS - 后台管理系统 ©{new Date().getFullYear()} Created by 安居客
                  </Footer>)
              : ''
          }}
          collapsed={false}
          collapsedButtonRender={false}
          breakpoint={false}
        >
          <div className={styles.cmsDefaultLayoutContent}>
            {(showBreadcrumb && breadcrumb && breadcrumb.length)
              ? (<div className={styles.breadcrumbContent}>
                  <Breadcrumb className={styles.breadcrumb}>
                    {(breadcrumb || []).map((item: any) => {
                      return <Breadcrumb.Item key={item.pathKey}>{item.title || item.name}</Breadcrumb.Item>
                    })}
                  </Breadcrumb>
                </div>)
              : ''}
            {this.props.children}
          </div>
        </ProLayout>
      </>
    )
  }
}

export default withRouter(DefaultLayout as any)
